<script lang="ts" setup>
import { KPlusCostOfKitForm } from '@entities/kPlus/ui';
import { UiModal } from '@shared/ui';
import { useCostOfKitForm } from './useModal';

const { isOpen, close, title } = useCostOfKitForm();
</script>

<template>
  <UiModal
    :is-open="isOpen"
    :actions="false"
    @close="close"
  >
    <KPlusCostOfKitForm
      :title="title"
      @close="close"
    />
  </UiModal>
</template>
